import { render, staticRenderFns } from "./industryTrendsDetails.vue?vue&type=template&id=2948d25e&scoped=true"
import script from "./industryTrendsDetails.vue?vue&type=script&lang=js"
export * from "./industryTrendsDetails.vue?vue&type=script&lang=js"
import style0 from "./industryTrendsDetails.vue?vue&type=style&index=0&id=2948d25e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2948d25e",
  null
  
)

export default component.exports